export const combineRegex = (regexes: RegExp[], flags: string) => {
  return new RegExp(regexes.map(regex => regex.source).join('|'), flags)
}
